import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, ListSubheader } from '@material-ui/core';

function ActionSelect({ selectFieldValue, handleSelectFieldChange, selectFieldError, userData, isCloud }) {
    return (
        <FormControl variant="outlined" fullWidth>
            <InputLabel id="ticket-id-label" error={selectFieldError}>Select an Action:</InputLabel>
            <Select
                value={selectFieldValue}
                onChange={handleSelectFieldChange}
                labelId="ticket-id-label"
                label="Select an Action:"
                autoWidth
                error={selectFieldError}
                sx={{ m: 0, minWidth: 320, maxWidth: 320 }}
            >
               <MenuItem value={"summarize_ticket"}>Provide a Ticket Summary</MenuItem>
                <MenuItem value={"recommend_solution"}>Recommend Step by Step Solution</MenuItem>
                {userData && userData.ssoAccessToken && isCloud && (
                    <MenuItem value={"recommend_solution_history"}>Recommend a Solution from Ticket History</MenuItem>
                )}
                {userData && userData.ssoAccessToken && isCloud && (
                    <MenuItem value={"similar_tickets_history"}>Find Similar Tickets from Ticket History</MenuItem>
                )}
                <MenuItem value={"best_solutions"}>Generate List of Possible Solutions</MenuItem>
                <MenuItem value={"generate_rca"}>Generate a Root Cause Analysis</MenuItem>
                <ListSubheader style={{ lineHeight: '20px' }}>-----------------------------------------------------------</ListSubheader>
                <MenuItem value={"recommend_title"}>Recommend a Title</MenuItem>
                <MenuItem value={"recommend_board"}>Recommend a Board</MenuItem>
                <MenuItem value={"recommend_priority"}>Recommend a Priority</MenuItem>
                <MenuItem value={"categorize_ticket"}>Recommend a Type, SubType and Item</MenuItem>
                <MenuItem value={"recommend_team"}>Recommend a Team</MenuItem>
                <MenuItem value={"recommend_agreement"}>Recommend an Agreement</MenuItem>
                <ListSubheader style={{ lineHeight: '20px' }}>-----------------------------------------------------------</ListSubheader>
                <MenuItem value={"email_response"}>Produce an Email Response to the Ticket Contact</MenuItem>
                <MenuItem value={"sanitize_text"}>Text Sanitizer and Email Generator</MenuItem>
                <ListSubheader style={{ lineHeight: '20px' }}>-----------------------------------------------------------</ListSubheader>
                <MenuItem value={"ticket_sentiment"}>Derive Contact Sentiment</MenuItem>
                <ListSubheader style={{ lineHeight: '20px' }}>-----------------------------------------------------------</ListSubheader>
                <MenuItem value={"translate_text"}>Text Translator</MenuItem>
                {userData && userData.ssoAccessToken && (
                    <MenuItem value={"search_university"}>Search ConnectWise University</MenuItem>
                )}
            </Select>
        </FormControl>
    );
}

export default ActionSelect;